var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransportPlanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,59h6c1.105,0,2-0.895,2-2v-5h3l-3-5v-3c0-4.971-4.029-9-9-9s-9,4.029-9,9v18h10V59z M14,44c0,0.551,0.449,1,1,1  s1-0.449,1-1h2c0,1.654-1.346,3-3,3s-3-1.346-3-3H14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.832,48.555l2-3c0.224-0.336,0.224-0.773,0-1.109l-2-3l-1.664,1.109L31.132,44H24v2h7.132l-0.964,1.445L31.832,48.555z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.168,13.445l1.664,1.109l2-3c0.224-0.336,0.224-0.773,0-1.109l-2-3l-1.664,1.109L40.132,10H33v2h7.132L39.168,13.445z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42,28H26c-1.654,0-3-1.346-3-3v-0.132l1.445,0.964l1.109-1.664l-3-2c-0.336-0.224-0.773-0.224-1.109,0l-3,2l1.109,1.664  L21,24.868V25c0,2.757,2.243,5,5,5h16c1.654,0,3,1.346,3,3v1h2v-1C47,30.243,44.757,28,42,28z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38,53h16V37H38V53z M49,44h2v2h-2V44z M45,44h2v2h-2V44z M41,44h2v2h-2V44z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30,2H14v16h16V2z M19,11h-2V9h2V11z M23,11h-2V9h2V11z M27,11h-2V9h2V11z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46,18h16V2H46V18z M50.707,9.293l2.166,2.165l4.313-6.039l1.628,1.162l-5,7c-0.171,0.239-0.438,0.391-0.731,0.416  C53.055,13.999,53.027,14,53,14c-0.264,0-0.519-0.104-0.707-0.293l-3-3L50.707,9.293z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportPlanner);
export default __webpack_public_path__ + "static/media/transport_planner.503bbaecd7e53856b570354e0db1a5df.svg";
export { ForwardRef as ReactComponent };